export default __webpack_public_path__ + "static/media/913a546fb07ec3db0c96ebf38883d6d41580239550566.b932d54e.webp";